import { Component, OnInit } from '@angular/core';
import { ScaffoldSidebarRef } from '@app/framework/sidebar/scaffold-sidebar.service';

@Component({
    selector: 'app-version-sidebar',
    templateUrl: './version-sidebar.component.html',
    styleUrls: ['./version-sidebar.component.scss'],
    standalone: false
})
export class VersionSidebarComponent implements OnInit {
  id;
  type;
  constructor(private sidebarRef: ScaffoldSidebarRef) {}

  ngOnInit(): void {}
  close() {
    this.sidebarRef.close();
  }
}
